import styled from 'styled-components';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { fontFamilyRoboto } from '@components/hoc/Theme/Theme.styled';

export const InputText = styled.input`
  font-size: 13px !important;
  font-family: ${fontFamilyRoboto};
  height: 40px;
  margin: 0 !important;
  width: 100%;
  border: 1px solid rgb(200, 200, 200);
  border-width: 0 0 1px 0;
  border-color: #c7c7c7;
  cursor: text;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #bbb;
    opacity: 0.9; /* Firefox */
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #bbb;
  }
  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #bbb;
  }
  &(:placeholder-shown) {
    border: 1px solid #007a64;
    border-width: 0 0 1px 0;
  }
  &:hover {
    border: 1px solid #60bead;
    border-width: 0 0 1px 0;
  }
  &:focus {
    border: 1px solid #60bead;
    border-width: 0 0 1px 0;
  }
  &:focus-visible {
    outline: none;
  }
  ${(props) =>
    props.$iserror
      ? 'border-color:#f11a48;'
      : 'background-color:none'};
`;

export const InputPhone = styled(PhoneInput)`
  .PhoneInputCountrySelect {
    /* Style the country select itself */
    font-size: 16px !important;
  }
`;
